/**
 * @generated SignedSource<<ef00c8c2ee992d834adb5d50020d796f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type videoListQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"videoListGridQuery">;
  readonly " $fragmentType": "videoListQuery";
};
export type videoListQuery$key = {
  readonly " $data"?: videoListQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"videoListQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sectionIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "videoListQuery",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "after",
          "variableName": "after"
        },
        {
          "kind": "Variable",
          "name": "count",
          "variableName": "count"
        },
        {
          "kind": "Variable",
          "name": "sectionIds",
          "variableName": "sectionIds"
        }
      ],
      "kind": "FragmentSpread",
      "name": "videoListGridQuery"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "20b99d265764e60f4cd42f4868bdf06a";

export default node;
